import React, {useEffect, useState} from "react"
import LoadingScreen from "react-loading-screen";
import logo from "../../assets/img/logo/logo_aig_login-2.png";
import Page from "../../components/Page";
import {urlListarPagos} from "../../constants/urls";
import {connect} from "react-redux"
import {withRouter} from "react-router-dom";
import {Card, CardBody, CardHeader,} from "reactstrap";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";

const MisPagosContainer = ({dataUsuario}) => {
  const [isLoading, setLoading] = useState(false);
  const [pagos, setPagos] = useState([]);
  const {cliCodigoCore} = dataUsuario
  const getData = async () => {
    setLoading(true)
    try {
      const res = await fetch(urlListarPagos(cliCodigoCore))
      const json = await res.json()
      console.log(json)
      if (json.transaccion) {
        setPagos(json.data)
      }
    } catch (e) {
      console.log(e)
    }
    setLoading(false)
  }
  useEffect(() => {
    getData()
  }, []);


  return (<main className="bg-light">
    <div className="cr-content container-fluid">
      <div className="container-body-spaces">
        <LoadingScreen
          loading={isLoading}
          bgColor="#f1f1f1"
          spinnerColor="#001871"
          textColor="#676767"
          logoSrc={logo}
          text={"Cargando Lista de Pagos..."}
        >
          <Page title="Listado de Pagos" breadcrumbs={[{name: "Listado de Pagos", active: true}]}>

            <div className="row">
              <div className="col-12 detalle-cotizacion-box">

                <Card className="mb-3">
                  <CardHeader style={{borderBottom: "none"}}/>

                  <CardBody>
                    {
                      //pagos.length > 0 &&
                      <DataTable
                        value={pagos}
                        responsive
                        className="p-datatable-customers"
                        rowHover
                        paginator
                        rows={10}
                        rowsPerPageOptions={[10, 25, 50]}
                        emptyMessage="No se han encontrado resultados"
                        resizableColumns
                      >
                        <Column
                          className="counter"
                          header="#"
                          body={(rowData, {rowIndex}) => {
                            return rowIndex + 1
                          }}
                          sortable
                          style={{minWidth: "60px"}}
                        />
                        <Column
                          field="fecha"
                          header="Fecha"
                          sortable
                          style={{minWidth: "100px"}}
                        />
                        <Column
                          field="referencia"
                          header="Referencia"
                          sortable
                          style={{minWidth: "100px"}}
                        />
                        <Column
                          field="numeroCompra"
                          header="Número de Compra"
                          sortable
                          style={{minWidth: "100px"}}
                        />
                        <Column
                          field="estadoPlacetopay"
                          header="Estado"
                          sortable
                          style={{minWidth: "100px"}}
                        />
                        <Column
                          field="valor"
                          header="Valor"
                          sortable
                          style={{minWidth: "100px"}}
                        />
                      </DataTable>
                    }
                  </CardBody>

                </Card>


              </div>
            </div>


            {pagos.length === 0 && (
              <div className="row">
                <div className="col-12 detalle-cotizacion-box">
                  <Card className="mb-3">
                    <CardHeader style={{borderBottom: "none"}}/>
                    <CardBody>
                      <h2 style={{color: "#001871", textAlign: "center"}}>
                        NO SE HA ENCONTRADO REGISTROS DE PAGOS REALIZADOS
                      </h2>
                    </CardBody>
                  </Card>
                </div>
              </div>
            )}

          </Page>
        </LoadingScreen>
      </div>
    </div>
  </main>)
}
const mapStateToProps = (state) => ({
  dataUsuario: state.datosUsuarios.dataUsuario
});

export default withRouter(
  connect(mapStateToProps, null)(MisPagosContainer)
);